import { execute } from '@lib/graphql/execute'
import { graphql } from '@lib/graphql/gql'
import { MutationConfig } from '@lib/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'

export const customerCreateTokenFormSchema = z.object({
  email: z.string().min(1, 'Email is required').email(),
  password: z.string().min(1, 'Password is required'),
})

export type CustomerCreateTokenFormValues = z.infer<
  typeof customerCreateTokenFormSchema
>

export const customerCreateTokenMutationDocument = graphql(`
  mutation CustomerCreateToken($email: String!, $password: String!) {
    customerAccessTokenCreate(input: { email: $email, password: $password }) {
      customerAccessToken {
        accessToken
        refreshToken
        expiresIn
      }
      errors {
        code: __typename
      }
    }
  }
`)

export const customerCreateToken = ({
  data,
}: {
  data: CustomerCreateTokenFormValues
}) => {
  return execute(customerCreateTokenMutationDocument, {
    email: data.email,
    password: data.password,
  })
}

type UseCustomerUpdateOptions = {
  mutationConfig?: MutationConfig<typeof customerCreateToken>
}

export const useCustomerSignIn = ({
  mutationConfig,
}: UseCustomerUpdateOptions = {}) => {
  const queryClient = useQueryClient()

  const { onSuccess, ...restConfig } = mutationConfig || {}

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args)
    },
    ...restConfig,
    mutationFn: customerCreateToken,
  })
}
